module.exports = __webpack_public_path__ + "img/17_105.8e4eefe2.png";